import { createFileRoute } from '@tanstack/react-router';

import { useAuth } from '@/app/auth';
import { HireLayoutRouteScreen } from '@/modules/simulation/route';

// Rota de layout de Contratar (W02-B, U53): os caminhos do legado continuam como filhos; o layout guarda o produto e a
// modalidade que o caminho decidiu e entrega o `sub` da sessão ao rascunho do fluxo (o módulo não importa `src/app`).
export const Route = createFileRoute('/_app/ccb/contratar')({ component: HireLayoutRoute });

function HireLayoutRoute() {
  const { user } = useAuth();
  return <HireLayoutRouteScreen user={user?.sub} />;
}
